import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) =>
          theme.palette.mode === 'dark' ? 'grey.100' : 'grey.900',
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', sm: 'center' },
          gap: 3,
        }}
      >
        {/* Left: Brand Info */}
        <Box>
          <Typography variant="h6" gutterBottom>
            TalentRealm
          </Typography>
          <Typography variant="body2" color="text.secondary">
            AI-powered platform connecting recruiters and candidates through smart
            resume-job matching. Built with React, Spring Boot, and OpenAI embeddings.
          </Typography>
        </Box>

        {/* Center: Quick Links */}
        <Stack direction="row" spacing={3}>
          <Link href="#features" color="inherit" underline="hover">
            Features
          </Link>
          <Link href="#pricing" color="inherit" underline="hover">
            Pricing
          </Link>
          <Link href="#faq" color="inherit" underline="hover">
            FAQ
          </Link>
          <Link href="#hero" color="inherit" underline="hover">
            Home
          </Link>
        </Stack>

        {/* Right: Social Icons */}
        <Stack direction="row" spacing={2}>
          <IconButton
            component="a"
            href="https://github.com/Aniketsonii"
            target="_blank"
            rel="noopener"
          >
            <GitHubIcon />
          </IconButton>
          <IconButton
            component="a"
            href="https://www.linkedin.com/in/aniketsonii"
            target="_blank"
            rel="noopener"
          >
            <LinkedInIcon />
          </IconButton>
          <IconButton
            component="a"
            href="https://www.instagram.com/visionsofaniket"
            target="_blank"
            rel="noopener"
          >
            <InstagramIcon />
          </IconButton>
        </Stack>
      </Container>

      {/* Bottom small print */}
      <Container maxWidth="lg" sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} TalentRealm by Aniket Soni. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}
